import { useMembership } from '@gr/portal/contexts/MembershipContext';
import { getSubDomain } from '@gr/portal/providers/auth0-data.provider';
import { getProductAuth0OrgId } from '@gr/portal/providers/auth0-product.provider';
import { Auth0OrganizationData, PRE_PROD_ORG_NAMES } from '@gr/shared/models';
import { isPreProdOrg } from '@gr/shared/utils';
import { orderBy } from 'lodash';
import { Dropdown, IDropdownValue } from '../Dropdown';

interface ISubDomainDropdownProps {
  value: IDropdownValue | undefined;
  onChange: (newValue?: IDropdownValue | undefined) => void;
  onBlur?: () => void;
  disabled?: boolean;
  errorMessage?: string | undefined;
  showError?: boolean;
}

const SubDomainDropdown = ({
  value,
  onChange,
  onBlur,
  disabled,
  errorMessage,
}: ISubDomainDropdownProps): JSX.Element => {
  const { organizations } = useMembership();

  const subDomain = getSubDomain();
  const isLocal = window.location.origin.includes('localhost');
  const isPreProd = PRE_PROD_ORG_NAMES.includes(subDomain?.toLowerCase()?.trim());

  const options = organizations
    ?.filter(org => !!org && org?.id !== getProductAuth0OrgId())
    ?.filter(org => (isPreProd || isLocal) ? isPreProdOrg(org) : true)
    ?.map(org => getOption(org))
    ?? [];

  const orderedOptions = isLocal
    ? orderBy(options, option => option.value === 'dev', 'desc')
    : orderBy(options, 'label');

  return (
    <Dropdown
      label="Organization"
      value={value}
      options={orderedOptions}
      onChange={onChange}
      onBlur={onBlur}
      error={errorMessage}
      disabled={disabled}
      full
      labelColor="black"
      className="px-3 pb-2"
    />
  );
};

function getOption(organization: Auth0OrganizationData): IDropdownValue {
  return {
    label: organization.display_name,
    value: organization.name,
    additionalData: {
      orgId: organization?.id,
    }
  };
}

export default SubDomainDropdown;
